function debounce(func: Function, wait: number, immediate: boolean) {
    let timeout: ReturnType<typeof setTimeout> = null;

    return function (...args: any[]) {
        let context = this;

        let later = function () {
            timeout = null;

            if (!immediate) {
                func.apply(context, args);
            }
        };

        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);

        if (callNow) {
            func.apply(this, args);
        }
    };
}

export default debounce;
